import {useEffect, useState} from 'react';
import {Configuration} from 'configuration';
import type {SystemHealth, SystemHealthStatus} from '../types';
import {aggregateSystemStatus} from '../functions/aggregateSystemStatus';
import {useGetHealthcheckQuery} from '../healthcheckApi';

const UPDATE_INTERVAL = 60 * 1000;
const INITIAL_DELAY = 2000; // 2 seconds delay to prevent blocking page load

const EBSDown: SystemHealth = {
  syncComponents: [],
  messageQueues: [],
  services: [
    {
      name: 'EBS',
      status: 'DOWN',
    },
  ],
};

export const useSystemHealth = (): {
  status: SystemHealthStatus;
  data: SystemHealth | undefined;
} => {
  const [started, setStarted] = useState(false);
  const {data, isError} = useGetHealthcheckQuery(undefined, {
    pollingInterval: Configuration.interval.healthcheck ?? UPDATE_INTERVAL,
    skip: !started,
    // limits re-renders to actual health changes (not status, etc)
    selectFromResult: ({data, isError}) => ({data, isError}),
  });

  useEffect(() => {
    setTimeout(() => {
      setStarted(true);
    }, INITIAL_DELAY);
  }, []);

  const aggregatedStatus = aggregateSystemStatus(isError, data);

  return {
    status: aggregatedStatus,
    data: isError ? EBSDown : data,
  };
};
